<template>
  <div class="container_self">
    <el-row class="table_parent">
      <el-row class="search_parent">
        <el-form :model="searchForm" :inline="true" size="mini">
          <el-form-item label="名称">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="包名">
            <el-input
              v-model="searchForm.packageName"
              clearable
              placeholder="请输入包名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>

      <h3>表盘列表</h3>
      <el-table
        :data="tableData"
        v-loading="loading"
        element-loading-text="加载中，请稍后"
        style="width: 100%"
      >
        <el-table-column align="center" prop="id" label="ID" width="55">
        </el-table-column>
        <el-table-column align="center" prop="name" label="名称" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="表盘图片" width="100">
          <template slot-scope="scope">
            <img
              v-if="scope.row.thumbnailUrl"
              :src="safeImgUrl(scope.row.thumbnailUrl)"
              referrerpolicy="no-referrer"
              class="dial-thumbnail"
              @click="handlePreview(safeImgUrl(scope.row.thumbnailUrl))"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="packageName" label="包名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="设备类型" width="90">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.deviceType"
              placement="top"
              :disabled="!scope.row.deviceType || scope.row.deviceType.length < 8"
            >
              <span class="text-ellipsis">{{ scope.row.deviceType }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="label" label="标签" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="shape" label="形状" width="80">
        </el-table-column>
        <el-table-column align="center" prop="resolutionRatio" label="分辨率" width="100">
        </el-table-column>
        <el-table-column align="center" prop="fileSize" label="文件大小" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.fileSize }} {{ scope.row.fileUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否免费" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isCharge ? 'warning' : 'success'" size="mini">
              {{ scope.row.isCharge ? '收费' : '免费' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否公开" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isPublic ? 'success' : 'info'" size="mini">
              {{ scope.row.isPublic ? '公开' : '私有' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否可用" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled ? 'success' : 'danger'" size="mini">
              {{ scope.row.enabled ? '可用' : '不可用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.originalPrice }} / {{ scope.row.preferentialPrice }} {{ scope.row.priceUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="coins" label="金币" width="60">
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间" width="155">
        </el-table-column>
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑表盘" :visible.sync="editDialogVisible" width="800px">
      <el-form :model="editForm" size="mini" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="表盘ID">
              <el-input v-model="editForm.dialId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="包名">
              <el-input v-model="editForm.packageName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型">
              <el-input v-model="editForm.deviceType"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="标签">
              <el-input v-model="editForm.label"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="形状">
              <el-input v-model="editForm.shape"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分辨率">
              <el-input v-model="editForm.resolutionRatio" placeholder="如 240*286"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文件大小">
              <el-input-number v-model="editForm.fileSize" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="文件单位">
              <el-input v-model="editForm.fileUnit" placeholder="KB"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="原价">
              <el-input-number v-model="editForm.originalPrice" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠价">
              <el-input-number v-model="editForm.preferentialPrice" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="价钱单位">
              <el-input v-model="editForm.priceUnit" placeholder="RMB"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="金币">
              <el-input-number v-model="editForm.coins" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否可用">
              <el-select v-model="editForm.enabled" style="width:100%;">
                <el-option label="不可用" :value="false"></el-option>
                <el-option label="可用" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="是否收费">
              <el-select v-model="editForm.isCharge" style="width:100%;">
                <el-option label="免费" :value="false"></el-option>
                <el-option label="收费" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否公开">
              <el-select v-model="editForm.isPublic" style="width:100%;">
                <el-option label="私有" :value="false"></el-option>
                <el-option label="公开" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="文件URL">
          <el-input v-model="editForm.fileUrl"></el-input>
        </el-form-item>
        <el-form-item label="缩略图URL">
          <el-input v-model="editForm.thumbnailUrl"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="editForm.description"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sureEdit" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览遮罩 -->
    <div class="preview-overlay" v-if="previewUrl" @click="previewUrl = ''">
      <img :src="safeImgUrl(previewUrl)" referrerpolicy="no-referrer" class="preview-img" />
    </div>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
export default {
  data() {
    return {
      total: 0,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      searchForm: {
        name: "",
        packageName: "",
      },
      editDialogVisible: false,
      previewUrl: "",
      editForm: {
        id: 0,
        name: "",
        dialId: "",
        packageName: "",
        deviceType: "",
        label: "",
        shape: "",
        resolutionRatio: "",
        fileSize: 0,
        fileUnit: "",
        fileUrl: "",
        thumbnailUrl: "",
        originalPrice: 0,
        preferentialPrice: 0,
        priceUnit: "",
        coins: 0,
        enabled: true,
        isCharge: false,
        isPublic: true,
        description: "",
      },
    };
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.getDialList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getDialList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDialList();
    },
    async getDialList() {
      this.loading = true;
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.searchForm.name) params.name = this.searchForm.name;
      if (this.searchForm.packageName) params.packageName = this.searchForm.packageName;
      const res = await axiosGet("/api/dial_settings/list", params);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },
    safeImgUrl(url) {
      if (!url) return "";
      // 通过 wsrv.nl 公共代理把 HTTP 图片转 HTTPS，解决 Mixed Content 问题
      return `https://wsrv.nl/?url=${encodeURIComponent(url)}&default=${encodeURIComponent(url)}`;
    },
    handlePreview(url) {
      this.previewUrl = url;
    },
    handleEdit(row) {
      this.editForm = {
        id: row.id,
        name: row.name || "",
        dialId: row.dialId || "",
        packageName: row.packageName || "",
        deviceType: row.deviceType || "",
        label: row.label || "",
        shape: row.shape || "",
        resolutionRatio: row.resolutionRatio || "",
        fileSize: row.fileSize || 0,
        fileUnit: row.fileUnit || "",
        fileUrl: row.fileUrl || "",
        thumbnailUrl: row.thumbnailUrl || "",
        originalPrice: row.originalPrice || 0,
        preferentialPrice: row.preferentialPrice || 0,
        priceUnit: row.priceUnit || "",
        coins: row.coins || 0,
        enabled: row.enabled,
        isCharge: row.isCharge,
        isPublic: row.isPublic,
        description: row.description || "",
      };
      this.editDialogVisible = true;
    },
    sureEdit() {
      if (!this.editForm.id) {
        this.$message({ message: "ID缺失", type: "error" });
        return;
      }
      axiosPost("/api/dial_settings/update", this.editForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "更新成功", type: "success" });
          this.editDialogVisible = false;
          this.getDialList();
        }
      });
    },
  },
  mounted() {
    this.getDialList();
  },
};
</script>
<style scoped>
.text-ellipsis {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dial-thumbnail {
  width: 49px;
  height: 60px;
  border-radius: 4px;
  cursor: pointer;
  object-fit: contain;
}
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: pointer;
}
.preview-img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dialManager/dialList.vue